import { useEffect, useState, useCallback } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Chip from '@mui/material/Chip'
import Skeleton from '@mui/material/Skeleton'
import Alert from '@mui/material/Alert'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import dayjs from 'dayjs'
import { adminListRaces, adminDeleteRace } from '../../api/admin'

export default function RaceList () {
  const [races, setRaces] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      setRaces((await adminListRaces()) || [])
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { load() }, [load])

  const handleDelete = async (race) => {
    if (!window.confirm(`Delete race "${race.title}"?`)) return
    try {
      await adminDeleteRace(race.slug)
      load()
    } catch (err) {
      setError(err.message)
    }
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant='h5' component='h1'>Races</Typography>
        <Button variant='contained' startIcon={<AddIcon />} component={RouterLink} to='/admin/dashboard/races/new'>
          New Race
        </Button>
      </Box>

      {error && <Alert severity='error' sx={{ mb: 2 }}>{error}</Alert>}

      {loading && <Skeleton variant='rectangular' height={400} />}

      {!loading && (
        <TableContainer component={Paper}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Slug</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Published</TableCell>
                <TableCell align='right'>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {races.map(race => (
                <TableRow key={race.slug} hover>
                  <TableCell>{race.title}</TableCell>
                  <TableCell>{race.slug}</TableCell>
                  <TableCell><Chip size='small' label={race.status} /></TableCell>
                  <TableCell>{race.date?.[0] ? dayjs(race.date[0]).format('DD MMM YYYY') : ''}</TableCell>
                  <TableCell>{race.published ? 'Yes' : 'No'}</TableCell>
                  <TableCell align='right' sx={{ whiteSpace: 'nowrap' }}>
                    <IconButton size='small' component={RouterLink} to={`/admin/dashboard/races/${race.slug}/edit`}>
                      <EditIcon fontSize='small' />
                    </IconButton>
                    <IconButton size='small' color='error' onClick={() => handleDelete(race)}>
                      <DeleteIcon fontSize='small' />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
}
